import * as yup from "yup"

const schemaValidationBusiness = yup.object().shape({})

export default schemaValidationBusiness
